export const PAYMENT_STATUS = {
  UPI: "UPI",
  BANK: "Bank Transfer",
  CASH: "Cash",
};
